import { css } from '@emotion/react';
import { ReactElement } from 'react';
import { useEffect } from 'react';
import { useState } from 'react';
import { IS_IE } from 'sdk';

import { styled } from '../../../../../styled';
import type { Theme } from '../../../../../theme/interface/detailed';

const Component = ({ file, className }: { file: File; className: string }): ReactElement => {
	const [imagePreviewUrl, setImagePreviewUrl] = useState('');
	useEffect(() => {
		const reader = new FileReader();
		reader.onloadend = (): void => {
			if (reader.result) {
				setImagePreviewUrl(reader.result.toString());
			}
		};
		reader.readAsDataURL(file);
	}, [file]);
	if (!IS_IE) return <img className={className} src={imagePreviewUrl} alt={file.name} />;
	return (
		<div
			className={className}
			css={css`
				div& {
					background-image: url(${imagePreviewUrl});
					background-position-x: left;
					background-position-y: center;
					background-repeat: no-repeat;
					background-origin: content-box;
					background-size: contain;
				}
			`}
		/>
	);
};

export const ImageAttachmentPreview = styled(Component)(
	({ theme }: { theme: Theme }) => theme.chat.attachments.unsentImagePreview,
	css`
		overflow: hidden;
		-ms-flex: 1 2 100%; /* IE */
		object-fit: contain;
	`
);
